
    import { css } from 'lit-element';
    export default css`*,:host{box-sizing:border-box}.kat-spacing-group>:last-child{--vertical-rhythm:0}`;
  